/**
 * @generated SignedSource<<19bd83da51c3445af585fa7ee62708c6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type hooksAdvertisementConfigQuery$variables = {
  id?: string | null | undefined;
};
export type hooksAdvertisementConfigQuery$data = {
  readonly appConfig: {
    readonly json: unknown | null | undefined;
  } | null | undefined;
};
export type hooksAdvertisementConfigQuery = {
  response: hooksAdvertisementConfigQuery$data;
  variables: hooksAdvertisementConfigQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "entityId",
            "variableName": "id"
          }
        ],
        "kind": "ObjectValue",
        "name": "filter"
      }
    ],
    "concreteType": "AppConfigs",
    "kind": "LinkedField",
    "name": "appConfig",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "json",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "hooksAdvertisementConfigQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "hooksAdvertisementConfigQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "91f2555a20918fde1a9986b0de738312",
    "id": null,
    "metadata": {},
    "name": "hooksAdvertisementConfigQuery",
    "operationKind": "query",
    "text": "query hooksAdvertisementConfigQuery(\n  $id: String\n) {\n  appConfig(filter: {entityId: $id}) {\n    json\n  }\n}\n"
  }
};
})();

(node as any).hash = "f63f6f4eb197a85a462b31461482cb84";

export default node;
